module.exports = __webpack_public_path__ + "img/Pro-1.6713d1ad.jpg";